
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'MultiChoiceCardsHeader'
})
export default class extends Vue {
}
